const mainTableItems = {
  id: "",
  date: "공사 시작일",
  jobCode: "Job code",
  fieldName: "현장 이름",
  projectName: "프로젝트 이름",
  file: "안전문서",
  delete: "",
};

const fileTableItems = {
  id: "",
  title: "항목",
  fileName: "첨부파일",
  writer: "작성자",
  memo: "비고",
  delete: "",
};

const adminTableItems = {
  id: "",
  userId: "아이디",
  name: "이름",
  role: "권한",
  createdAt: "가입일",
  delete: "",
};

export { mainTableItems, fileTableItems, adminTableItems };
